import { useEffect } from 'react';

export function useScrollLock(lock) {
    useEffect(() => {
        const scrollY = window.scrollY;

        if (lock) {
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.overflowY = 'scroll';
            document.body.style.width = '100%';
        }

        return () => {
            if (lock) {
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.left = '';
                document.body.style.right = '';
                document.body.style.overflowY = '';
                document.body.style.width = '';
                window.scrollTo(0, scrollY);
            }
        };
    }, [lock]);
}
